<template>
  <div class="footer">
    <div class="guild">
      <!-- <p>© 2018-2019 杭州小步智学教育科技有限公司 客服电话：15505882806</p>
      <p class="company">
        Copyright © 2018-2019 增值电信业务经营许可证： 浙B2-20190034
      </p> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: 100px;
}
.footer .guild {
  width: 390px;
  height: 38px;
  margin: 0 auto;
  font-size: 12px;
  color: #999;
  padding-top: 37px;
}
.footer .guild .company {
  padding-top: 5px;
}
</style>
